<label class="form-label"
  [for]="id">
  {{props.label}} @if (props.required) {
  <span>*</span>
}
</label>
<input type="date"
  [attr.data-testid]="'form-datepicker-' + id"
  [id]="id"
  [formControl]="control"
  [formlyAttributes]="field"
  [class.is-invalid]="showError"
  class="form-control" />

